import { formatDate } from '@/util/tool'
import NP from 'number-precision'

export function signStateFilters (val) { // 合同状态
  if (val === 1) {
    return '待审核'
  } else if (val === 2) {
    return '审核中'
  } else if (val === 3) {
    return '审核通过待签署'
  } else if (val === 4) {
    return '履行中'
  } else if (val === 5) {
    return '已履行'
  } else if (val === 6) {
    return '已作废'
  } else if (val === 7) {
    return '审核不通过'
  } else if (val === 8) {
    return '盖章审核'
  } else if (val === 9) {
    return '盖章审核不通过'
  } else if (val === 0) {
    return '未签'
  } else {
    return '--'
  }
}

export function payTypeFilters (val) { // 付款类型
  if (val === 1) {
    return '约定账期'
  } else if (val === 2) {
    return '全款发货'
  } else if (val === 3) {
    return '先货后款'
  } else if (val === 4) {
    return '期货期款'
  } else {
    return '--'
  }
}

export function stockupStateFilter (val) { // 备货状态
  if (val === 0) {
    return '待备货'
  } else if (val === 1) {
    return '备货审核'
  } else if (val === 2) {
    return '待配货'
  } else if (val === 3) {
    return '配货中'
  } else if (val === 4) {
    return '备货中'
  } else if (val === 5) {
    return '已备货'
  } else if (val === 6) {
    return '审核不通过'
  } else if (val === 7) {
    return '释放库存审核中'
  } else if (val === 8) {
    return '库存释放通过'
  } else if (val === 9) {
    return '库存释放不通过'
  } else {
    return '--'
  }
}
export function deliverStateFilter (val) { // 发货状态
  if (val === 0) {
    return '未发货'
  } else if (val === 1) {
    return '发货审核'
  } else if (val === 2) {
    return '待发货'
  } else if (val === 3) {
    return '已发货'
  } else if (val === 4) {
    return '审核不通过'
  } else if (val === 5) {
    return '设置出库单'
  } else if (val === 6) {
    return '已作废'
  } else {
    return '--'
  }
}
export function invoiceStateFilter (val) { // 开票状态
  if (val === 0) {
    return '未开票'
  } else if (val === 1) {
    return '开票审核'
  } else if (val === 2) {
    return '已开票'
  } else if (val === 3) {
    return '审核不通过'
  } else if (val === 4) {
    return '已退票'
  } else if (val === 5) {
    return '退票审核'
  } else {
    return '--'
  }
}
export function salesReturnStateFilter (val) { // 退货状态
  if (val === 1) {
    return '退货审批'
  } else if (val === 3) {
    return '审批不通过'
  } else if (val === 4) {
    return '制定结算方案'
  } else if (val === 5) {
    return '费用结算审批'
  } else if (val === 6) {
    return '结算审批不通过'
  } else if (val === 7) {
    return '票据回收'
  } else if (val === 8) {
    return '待入库'
  } else if (val === 9) {
    return '已入库'
  } else if (val === 10) {
    return '费用结算'
  } else if (val === 11) {
    return '放弃退货'
  } else if (val === 12) {
    return '退货完成'
  } else {
    return '--'
  }
}
export function formatData (val) {
  if (!val) return '--'
  try {
    const date = new Date(val)
    const year = date.getFullYear()
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    const day = date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()
    const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    return `${year}-${month}-${day}  ${hours}:${minutes}`
  } catch (e) {
    return val
  }
}

export function isNoData (val) {
  return !val && val !== 0 ? '--' : val
}

export function isNoDataex (val) {
  if (Number(val)) {
    return toFixed(val)
  }
  return isNoData(val)
}
export function toFixed (val, n = 2) {
  if (!val || val === '0') return '0.00'
  return val.toFixed(n)
}

export function toPercentFormat (n) {
  const nex = Number(n) ? n : 0
  return NP.strip(nex * 100).toFixed(2) + '%'
}

export function priceFilter (num) { // 保留两位小数(默认--)
  return !num ? '0.00' : parseFloat(num).toFixed(2)
}
export function priceFilterNum (num) { // 保留两位小数(默认0.00)
  return !num ? '0.00' : parseFloat(num).toFixed(2)
}
export function dateFilter (time) { // 时间戳
  return time === null ? '--' : formatDate(new Date(time), 'yyyy-MM-dd hh:mm')
}
export function dateFilterL (time) { // 时间戳
  return time === null ? '--' : formatDate(new Date(time), 'yyyy-MM-dd hh:mm')
}
export function dateFilterD (time) { // 时间戳 到天
  return !time ? '--' : formatDate(new Date(time), 'yyyy-MM-dd')
}
export function perCentFilter (num) { // 百分号 默认--
  return !num ? '0.00%' : (num * 100).toFixed(2) + '%'
}
export function perCentFilterL (num) { // 百分号 默认--
  return !num ? '0%' : (num * 100).toFixed(0) + '%'
}
